import {
    createNotificationComponent,
    INotificationProperties,
} from '@vfde-brix/notification';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { RaError } from '../container/RoamingAdvisor/types';
import { NOTIFICATION_CONTAINER } from '../container/RoamingAdvisor/constants';

/**
 * LoadingSpinner BRIX component
 *
 */
export const mountNotification = (error: RaError) => {
    const notificationContainer = document.getElementById(NOTIFICATION_CONTAINER);

    const data: INotificationProperties = {
        stdTitle: error.headline,
        optHidden: false,
        txtContent: error.content,
        optType: error.seriousError ? 'error' : 'info',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return createNotificationComponent(notificationContainer, data);
};
